import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../problems/problem.service';

@Injectable()
export class TaskReviewTaskFilesService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public review(taskId: string, fileType: string): Observable<any> {
    const url = `${this.configService.config.rest.apiV2Url}/tasks/${taskId}/set-files-reviewed`;

    return this.client.post(url, {type: fileType}).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
